var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _excluded = ["direction", "children", "enterTimeout", "exitTimeout"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { ClassNames } from "@emotion/core";
import * as React from "react";
import { Transition } from "react-transition-group";
import { jsx as ___EmotionJSX } from "@emotion/core";
var initialTransforms = {
  up: "scale(1, 0.5) translate(0, 1.5rem)",
  down: "scale(1, 0.5) translate(0, -1.5rem)",
  left: "scale(0.5, 1) translate(1.5rem, 0)",
  right: "scale(0.5, 1) translate(-1.5rem, 0)"
};
var exitingTransforms = {
  up: "scale(1, 0.75)",
  down: "scale(1, 0.75)",
  left: "scale(0.75, 1)",
  right: "scale(0.75, 1)"
};
var origins = {
  up: "50% 100%",
  down: "50% 0",
  left: "100% 50%",
  right: "0 50%"
};
export default function SlideTransition(_ref) {
  var direction = _ref.direction,
      children = _ref.children,
      _ref$enterTimeout = _ref.enterTimeout,
      enterTimeout = _ref$enterTimeout === void 0 ? 150 : _ref$enterTimeout,
      _ref$exitTimeout = _ref.exitTimeout,
      exitTimeout = _ref$exitTimeout === void 0 ? 150 : _ref$exitTimeout,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return ___EmotionJSX(Transition, _extends({
    timeout: {
      enter: enterTimeout,
      exit: exitTimeout
    }
  }, props), function (state) {
    return ___EmotionJSX(ClassNames, null, function (_ref2) {
      var cx = _ref2.cx,
          css = _ref2.css;
      var base = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n              opacity: 0;\n              transform: ", ";\n              transform-origin: ", ";\n              transition: all ", "ms ease-out;\n            "])), initialTransforms[direction], origins[direction], exitTimeout);
      var transition = "";

      if (state === "entering" || state === "entered") {
        transition = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n                visibility: visible;\n                opacity: 1;\n                transform: scale(1, 1) translate(0, 0);\n                transition-duration: ", "ms;\n              "])), enterTimeout);
      }

      if (state === "exiting") {
        transition = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n                opacity: 0;\n                transform: ", ";\n              "])), exitingTransforms[direction]);
      }

      if (state === "exited") {
        transition = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n                visibility: hidden;\n              "])));
      }

      var child = React.Children.only(children);
      if (!React.isValidElement(child)) return null;
      return React.cloneElement(child, {
        className: cx(base, transition)
      });
    });
  });
}